import { Helmet } from "react-helmet-async";

const SITE = "https://jerseyblend.net";
const DEFAULT_IMG = `${SITE}/og-image.jpg`;

// Per-page SEO: unique title/description/canonical + Open Graph + Twitter + optional JSON-LD.
export default function Seo({ title, description, path = "", image, jsonLd, keywords }) {
  const url = `${SITE}${path}`;
  const img = image || DEFAULT_IMG;
  const fullTitle = title || "Jersey Blend | Custom Soccer, NFL & NBA Fan Jerseys on Hoodies & Tees";
  const desc =
    description ||
    "Original fan-made soccer, NFL & NBA designs on premium hoodies and tees. Personalize the back with your name and number. 7 garment colors.";
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Jersey Blend" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
